export default {}

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SIGN_UP = 'SIGN_UP'
export const UPDATE_USER = 'UPDATE_USER'
export const FETCH_SIGN_UP_DATA = 'FETCH_SIGN_UP_DATA'
export const EMAIL_CHECK = 'EMAIL_CHECK'
export const RESEND_EMAIL_CONFIRMATION = 'RESEND_EMAIL_CONFIRMATION'
export const UPDATE_ACCOUNT_STATUS = 'UPDATE_ACCOUNT_STATUS'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const EDIT_PROFILE = 'EDIT_PROFILE'
export const UNSUBSCRIBE_EMAIL = 'UNSUBSCRIBE_EMAIL'
export const UNSUBSCRIBE_EMAIL_BY_TOKEN = 'UNSUBSCRIBE_EMAIL_BY_TOKEN'
export const GET_PROFILE_DATA = 'GET_PROFILE_DATA'
export const EDIT_EMAIL = 'EDIT_EMAIL'
export const EMAIL_CHANGE_CONFIRMATION = 'EMAIL_CHANGE_CONFIRMATION'
export const UPDATE_PRIVACY = 'UPDATE_PRIVACY'
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE"
export const UPDATE_UNITS = "UPDATE_UNITS"
export const LANGUAGE_CHANGED_ON_SIGN_UP = "LANGUAGE_CHANGED_ON_SIGN_UP"
export const INTEGRATIONS = "INTEGRATIONS"
export const INTEGRATIONS_SELECT_CHILD = "INTEGRATIONS_SELECT_CHILD"

// CALENDAR
export const FETCH_CALENDAR_DATA = 'FETCH_CALENDAR_DATA'
export const CHANGE_CALENDAR_SESSION_TYPES = 'CHANGE_CALENDAR_SESSION_TYPES'
export const UPDATE_CALENDAR_STORAGE = 'UPDATE_CALENDAR_STORAGE'
export const UPDATE_PREVIEW_MODE= 'UPDATE_PREVIEW_MODE'
export const FETCH_FILTER_DATA_FROM_STORAGE = 'FETCH_FILTER_DATA_FROM_STORAGE'
export const UPDATE_VIEW_DATE = 'UPDATE_VIEW_DATE'
export const RESET_STATE = 'RESET_STATE'

// CALENDAR ACTIVITY
export const FETCH_CALENDAR_ACTIVITY_DATA = 'FETCH_CALENDAR_ACTIVITY_DATA'
export const CACHE_DASHBOARD_ACTIVITY_DATA = 'CACHE_DASHBOARD_ACTIVITY_DATA'
export const CHANGE_CALENDAR_ACTIVITY_METRIC = 'CHANGE_CALENDAR_ACTIVITY_METRIC'
export const CHANGE_HR_SELECTED_UNIT = 'CHANGE_HR_SELECTED_UNIT'
export const CHANGE_AVG_HR_SELECTED_UNIT = 'CHANGE_AVG_HR_SELECTED_UNIT'
export const CHANGE_TOP_HR_SELECTED_UNIT = 'CHANGE_TOP_HR_SELECTED_UNIT'
export const CHANGE_AP_ZONES_SELECTED_UNIT = 'CHANGE_AP_ZONES_SELECTED_UNIT'
export const CHANGE_WORKLOAD_ZONES_SELECTED_UNIT = 'CHANGE_WORKLOAD_ZONES_SELECTED_UNIT'
export const CHANGE_DISTANCE_ZONES_SELECTED_UNIT = 'CHANGE_DISTANCE_ZONES_SELECTED_UNIT'
export const CHANGE_HR_CHART_UNIT = 'CHANGE_HR_CHART_UNIT'
export const CHANGE_DISTANCE_CHART_UNIT = 'CHANGE_DISTANCE_CHART_UNIT'
export const CHANGE_LIST_OF_SELECTED_CALENDAR_TEAMS = 'CHANGE_LIST_OF_SELECTED_CALENDAR_TEAMS'
export const UPLOAD_ACTIVITY_ATTACHMENT = 'UPLOAD_ACTIVITY_ATTACHMENT'
export const DELETE_ACTIVITY_ATTACHMENT = 'DELETE_ACTIVITY_ATTACHMENT'
export const CHANGE_ACTIVITY_DESCRIPTION = 'CHANGE_ACTIVITY_DESCRIPTION'
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY'
export const DESTROY_ACTIVITY_DATA = 'DESTROY_ACTIVITY_DATA'
export const FETCH_ACTIVITY_SELECTIONS = 'FETCH_ACTIVITY_SELECTIONS'
export const CREATE_ACTIVITY_SEGMENT = 'CREATE_ACTIVITY_SEGMENT'
export const DELETE_ACTIVITY_SEGMENT = 'DELETE_ACTIVITY_SEGMENT'
export const ADD_TO_FILTERED_SEGMENT = 'ADD_TO_FILTERED_SEGMENT'
export const REMOVE_FROM_FILTERED_SEGMENT = 'REMOVE_FROM_FILTERED_SEGMENT'
export const SELECT_DESELECT_ALL_SEGMENT = 'SELECT_DESELECT_ALL_SEGMENT'
export const SELECT_STATS_TABLE_SEGMENT = 'SELECT_STATS_TABLE_SEGMENT'
export const FETCH_STATS_TABLE_SEGMENTS = 'FETCH_STATS_TABLE_SEGMENTS'
export const FETCH_TIMELINE_CHART_DATA = 'FETCH_TIMELINE_CHART_DATA'

//SESSION HISTORY
export const FETCH_SESSION_HISTORY_DATA = "FETCH_SESSION_HISTORY_DATA"
export const FETCH_MORE_PRECISE_ACTIVITY_DATA = 'FETCH_MORE_PRECISE_ACTIVITY_DATA'

// TEAMS
export const FETCH_PLAYER_TEAMS = 'FETCH_PLAYER_TEAMS'

// DASHBOARD
export const FETCH_TIMELINE_DATA_FOR_TEAM = 'FETCH_TIMELINE_FOR_TEAM'
export const FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA'
export const FETCH_TIMELINE_DATA_FOR_ALL_TEAMS = 'FETCH_TIMELINE_DATA_FOR_ALL_TEAMS'
export const FETCH_INDIVIDUAL_TIMELINE_DATA = 'FETCH_INDIVIDUAL_TIMELINE_DATA'
export const FETCH_DASHBOARD_DATA_FOR_TEAM = 'FETCH_DASHBOARD_DATA_FOR_TEAM'
export const FETCH_DASHBOARD_DATA_FOR_ALL_TEAMS = 'FETCH_DASHBOARD_DATA_FOR_ALL_TEAMS'
export const FETCH_INDIVIDUAL_DASHBOARD_DATA_FOR_ALL_TEAMS = 'FETCH_INDIVIDUAL_DASHBOARD_DATA_FOR_ALL_TEAMS'
export const CHANGE_SELECTED_ENTITY = 'CHANGE_SELECTED_ENTITY'
export const CHANGE_SELECTED_TEAM = 'CHANGE_SELECTED_TEAM'
export const CHANGE_TIMERANGE = 'CHANGE_TIMERANGE'
export const CHANGE_SELECTED_METRIC = 'CHANGE_SELECTED_METRIC'
export const CHANGE_TIMERANGE_TO_DATE = 'CHANGE_TIMERANGE_TO_DATE'
export const CHANGE_TIMERANGE_FROM_DATE = 'CHANGE_TIMERANGE_FROM_DATE'
export const RESET_DASHBOARD_STATE = 'RRESET_DASHBOARD_STATEESET_STATE'
export const DASHBOARD_NO_DATA = 'DASHBOARD_NO_DATA'
export const UPDATE_INITIAL_DATA_FETCHED = 'UPDATE_INITIAL_DATA_FETCHED'

// ADDITIONAL EMAIL
export const ADD_ADDITIONAL_EMAIL = 'ADD_ADDITIONAL_EMAIL'
export const DELETE_ADDITIONAL_EMAIL = 'DELETE_ADDITIONAL_EMAIL'
export const RESEND_ADDITIONAL_EMAIL = 'RESEND_ADDITIONAL_EMAIL'
export const CONFIRM_ADDITIONAL_EMAIL = 'CONFIRM_ADDITIONAL_EMAIL'

export const getMockedData = 'getMockedData'

// LEADERBOARD
export const FETCH_LEADERBOARD_DATA = 'FETCH_LEADERBOARD_DATA';
export const CHANGE_LEADERBOARD_TEAM_INDIVIDUAL = 'CHANGE_LEADERBOARD_TEAM_INDIVIDUAL';
export const CHANGE_LEADERBOARD_SCOPE = 'CHANGE_LEADERBOARD_SCOPE';
export const CHANGE_LEADERBOARD_AGREGATION_METHOD = 'CHANGE_LEADERBOARD_AGREGATION_METHOD';
export const FETCH_LEADERBOARD_TEAMS = 'FETCH_LEADERBOARD_TEAMS';
export const UPDATE_LEADERBOARD_SELECTED_TEAM = 'UPDATE_LEADERBOARD_SELECTED_TEAM';
export const CHANGE_LEADERBOARD_TIME_FRAME = 'CHANGE_LEADERBOARD_TIME_FRAME';
export const DESTROY_LEADERBOARD_DATA = 'DESTROY_LEADERBOARD_DATA';
export const FETCH_PLAYER_LEADERBOARD_DATA = 'FETCH_PLAYER_LEADERBOARD_DATA';
export const UPDATE_SYSTEM_WIDE_PRIVACY = 'UPDATE_SYSTEM_WIDE_PRIVACY';
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";

export const GET_PLAYER_POSITIONS = 'GET_PLAYER_POSITIONS'
